import { Country } from "../models/country";

export async function fetchCountries(): Promise<Country[]> {
    const url = `${import.meta.env.VITE_BE_API_DOMAIN}countries`;

    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch countries data');
    return response.json();
}